/* eslint-disable consistent-return */
// Global Style Components
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { Button } from '@design-system-coopeuch/web';

export const StyledWrapperInputMaxLength = styled.article`
& > div {
  & > div:nth-of-type(2) >  div:nth-of-type(2) {
      text-align: right
  }
}
`;

export const StyledWrapperInput = styled.article`
  position: relative;
  & > div {
    & > label {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 4px;
    }
    & > div:nth-of-type(1) {
      /* para deshabilitar el click en el div que llama a la lista desplegable de inputCounter */
      & div[role='button'] {
        pointer-events: none;
        & i {
          display: none;
        }
      }
      /* para deshabilitar el div con las opciones del inputCounter en el caso que se use tabulacion */
      & > div:nth-of-type(3) {
        display: none;
      }
      & input {
        color: #383838;
      }
    }

    & > div:nth-of-type(2) {
      margin-top: 4px;
    }
    /* para ocultar la flechita del seleccionable */
    /* & div > div:nth-child(1) i {
      display: none;
      pointer-events: none;
    } */
    /* para que el input text despues del +56 no tenga tanto padding-left */
    & div > div:nth-child(2) input {
      padding-left: calc(2rem + 27px);
    }
  }
`;

export const StyledWrapperMessage = styled.div`
  width: 100%;
`;

export const StyledWrapperInputSelect = styled.div`
  & .Autocomplete-selector > label {
    font-size: 16px;
  }
  & > div > div:nth-child(3) > div {
    z-index: 9999;
  }
`;

export const WrapperCheckboxs = styled.div`
  & label {
    display: flex;
    align-items: center;
    & div {
      flex: 0 0 36px;
    }
    & svg {
      margin: 0px !important;
    }
    & div::after {
      width: 40px !important;
      left: -8px !important;
      @media screen and (min-width: 768px) {
        top: 0px;
      }
      cursor: pointer;
    }
  }
`;

export const WrapperRadio = styled.div`
  & > div {
    display: flex;
    & > div {
      flex: 0 0 40px;
      /* justify-content: start !important; */
    }
  }
`;

export const WrapperCheckbox = styled.div`
  /* Contenedor de checkbox para personalizar, por ahora el estado error */
  ${(props) => {
    switch (props.validationStatus) {
      case 'error':
        return `
          & label {
            color: #CC284E;
            & svg path {
              fill: #CC284E;
            }
          }
        `;
      case 'required':
        return `
          & label {
            & svg path {
              fill: #CC284E;
            }
          }
        `;
      default:
        break;
    }
  }}
`;

export const StyledWrapperCardBaseButtons = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  & > button {
    margin: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    color: #f42534;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    align-items: center;
    & > span {
      margin-right: 0.5rem;
    }
  }
`;

export const StyledButton = styled(Button)`
  display: flex !important;
  & > span {
    font-size: 16px;
  }
  & i {
    font-size: ${(props) =>
      props.sizeIcon ? `${props.sizeIcon}px !important` : '24px !important'};
  }
  ${(props) =>
    props.appearanceDisabled
      ? `
      background-color: #d4d4d4 !important;
      color: white;
      &:hover {
        background-color: #d4d4d4 !important;
        color: white;
        cursor: default;
        box-shadow: 0 2px 4px 0 rgb(30 30 30 / 35%);
      }
  `
      : ''};
  /* @media screen and (min-width: 768px) {
    width: 100%;
    justify-content: center;
    // lo comentamos por que afecta a los botones descargar de los contratose en desktop
  } */
`;

export const StyledButtonCenter = styled(Button)`
  justify-content: center;
  padding: 0px;

  & > span {
    font-size: 16px;
  }
`;

export const StyledWrapperDropdown = styled.article`
  & > div {
    border: 0px;
  }
  & > div > div:nth-child(1) {
    padding: 0px;
    /* border-bottom: 0px; */
    & p {
      line-height: 20px;
    }
  }
  & > div > div:nth-child(2) {
    padding: 0px;
    border-top: 0px;
    & ul {
      margin-top: 4px;
      display: grid;
      grid-row-gap: 10px;
      list-style: none;
      padding-left: 16px;
    }
    & ul li {
      line-height: 18px;
    }
    & ul li::before {
      content: '\\2022';
      color: #007dbc;
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1rem;
    }
  }
`;

export const StyledLoader = styled.div`
  background-color: rgb(255, 255, 255, 0.8);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 30000;
  height: 100vh;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RadioContainer = styled.div`
  & p {
    font-size: 16px;
    line-height: 24px;
  }
  & label {
    width: auto;
    margin-right: 12px;
  }
  & label::after {
    left: -8px;
    width: 165%;
    @media screen and (min-width: 768px) {
      width: 150%;
    }
  }
`;
